import { type WorkerRequirement } from "@src/appV2/redesign/Documents/api/types";

interface GetIndividualBlockingRequirementsProps {
  visibleBlockingRequirements: WorkerRequirement[];
  invisibleBlockingRequirements: WorkerRequirement[];
  inReviewVisibleBlockingRequirements: WorkerRequirement[];
  notInReviewVisibleBlockingRequirements: WorkerRequirement[];
  hasExternalBlockingCards: boolean;
}

export function getIndividualBlockingRequirements(props: GetIndividualBlockingRequirementsProps) {
  const {
    visibleBlockingRequirements,
    invisibleBlockingRequirements,
    inReviewVisibleBlockingRequirements,
    notInReviewVisibleBlockingRequirements,
    hasExternalBlockingCards,
  } = props;

  if (visibleBlockingRequirements.length === 0) {
    return hasExternalBlockingCards ? [] : invisibleBlockingRequirements;
  }

  return notInReviewVisibleBlockingRequirements.length === 0
    ? inReviewVisibleBlockingRequirements
    : notInReviewVisibleBlockingRequirements;
}
